import { DOCUMENT } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { ReplaySubject } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { DatahubService } from '../../../services/datahub.service';
import { LogRocketService } from '../../../services/log-rocket.service';

@Component({
  selector: 'app-modal-content-about',
  templateUrl: './modal-content-about.component.html',
  standalone: false,
})
export class ModalContentAboutComponent {
  public readonly deviceType = this.getDeviceType();
  public readonly appVersion: string = environment.appVersion;
  public readonly envName = environment.environmentNameFull;
  public logRocketURLSubject$: ReplaySubject<string> = this.LogRocket.readySubject$;

  private readonly window = this.document.defaultView;

  constructor(
    private readonly datahub: DatahubService,
    private readonly LogRocket: LogRocketService,
    @Inject(DOCUMENT) private readonly document: Document,
  ) {}

  public get userName(): string {
    return this.datahub.userService.getName();
  }

  public get employeeNumber(): string {
    return this.datahub.userService.getEmployeeNumber();
  }

  public get homeCostCenter(): string {
    return this.datahub.userService.getCcInfo().CostCenter;
  }

  public clearLocalStorageAndReload(): void {
    this.window?.localStorage.clear();
    this.window?.location.reload();
  }

  public selectLogRocketUrl(ev: MouseEvent): void {
    (ev.target as HTMLInputElement).select();
  }

  private getDeviceType(): string {
    const ua = navigator.userAgent;
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
      return 'Tablet';
    } else if (/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
      return 'Mobile';
    } else {
      return 'Desktop';
    }
  }
}
